if (!customElements.get("accesssory-list")) {
  class AccesssoryList extends HTMLElement {

    constructor() {
      super();
      this.accesssoryItems = this.querySelectorAll('.products-tab__accessory-item')
    }

    connectedCallback() {
        this.accesssoryItems.forEach(accesssoryItem => {
            accesssoryItem.addEventListener("click", (e) => {
                if(accesssoryItem.dataset.free == 'false') {
                    if(accesssoryItem.dataset.check == 'false') {
                        this.checkedAccessory(accesssoryItem)
                        accesssoryItem.dataset.check = 'true';
                        
                    }else {
                        this.uncheckAccessory(accesssoryItem)
                        accesssoryItem.dataset.check = 'false';
                    }
                }
            })
        })

        this.initAccessoryStatus();
    }

    initAccessoryStatus() {
        this.accesssoryItems.forEach(accesssoryItem => {
            if(accesssoryItem.dataset.free == 'false') {
                if(accesssoryItem.dataset.check == 'true') {
                    this.checkedAccessory(accesssoryItem);
                }
            }
        })
    }

    checkedAccessory(accesssoryItem) {
        const variantId = accesssoryItem.dataset.variantId;
        const quantity = accesssoryItem.dataset.quantity;
        const index = accesssoryItem.dataset.index - 1;
        const blockClass = accesssoryItem.dataset.block;
        const buttons = document.querySelectorAll(`.${blockClass} .products-tab__price-buttons .products-tab__buy-buttons`);
        console.log(index)
        console.log(buttons)
        buttons.forEach((container,ind) => {
            if(ind == index) {
                const buyButton = container.querySelector('.products-tab__buy-now')
                const addButton = container.querySelector('.products-tab__cart')
                let ids = buyButton.getAttribute('data-variant-id').split(',');
                let quantityList = buyButton.getAttribute('data-quantity').split(',');
                const findIndex = ids.findIndex((id) => id == variantId);
                if (findIndex <= -1) {
                    // add id, quantity
                    ids.push(variantId);
                    quantityList.push(quantity);
                } else {
                    // update quantity
                    quantityList[findIndex] = quantity;
                }
                buyButton.setAttribute('data-variant-id', ids.join(','));
                buyButton.setAttribute('data-quantity', quantityList.join(','));
                addButton.setAttribute('data-variant-id', ids.join(','));
                addButton.setAttribute('data-quantity', quantityList.join(','));
            }
        })
    }

    uncheckAccessory(accesssoryItem) {
        const variantId = accesssoryItem.dataset.variantId;
        const quantity = accesssoryItem.dataset.quantity;
        const index = accesssoryItem.dataset.index - 1;
        const blockClass = accesssoryItem.dataset.block;
        const buttons = document.querySelectorAll(`.${blockClass} .products-tab__price-buttons .products-tab__buy-buttons`);
        buttons.forEach((container,ind) => {
            if(ind == index) {
                const buyButton = container.querySelector('.products-tab__buy-now')
                const addButton = container.querySelector('.products-tab__cart')
                let ids = buyButton.getAttribute('data-variant-id').split(',');
                let quantityList = buyButton.getAttribute('data-quantity').split(',');
                const findIndex = ids.findIndex((id) => id == variantId);
                if (findIndex > -1) {
                    // remove id, quantity
                    ids.splice(findIndex, 1);
                    quantityList.splice(findIndex, 1);
                }
                buyButton.setAttribute('data-variant-id', ids.join(','));
                buyButton.setAttribute('data-quantity', quantityList.join(','));
                addButton.setAttribute('data-variant-id', ids.join(','));
                addButton.setAttribute('data-quantity', quantityList.join(','));
            }
        })
    }
  }

  customElements.define("accesssory-list", AccesssoryList);
}